import { Observable } from "rxjs"
import { AccountLimit } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function AutoFilterPortalsGetObservable(filter: string): Observable<string[]> {
  const requestBody: string = JSON.stringify({ Name: filter, Limit: AccountLimit })
  return ObservableFromFetch<string[]>("FFOrderClinicFileMaintenance/PortalWildcardSearch", requestBody)
}
